module.exports = __webpack_public_path__ + "img/case-logo-26.224a8984.png";